import { Injectable, signal } from '@angular/core';

export interface ConsultationPrefill {
  projectType?: string;
  estimatedBudget?: string;
  suburb?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConsultationService {
  private isModalOpenSignal = signal<boolean>(false);
  private prefillDataSignal = signal<ConsultationPrefill>({});

  readonly isModalOpen = this.isModalOpenSignal.asReadonly();
  readonly prefillData = this.prefillDataSignal.asReadonly();

  openModal(prefill?: ConsultationPrefill) {
    if (prefill) {
      this.prefillDataSignal.set(prefill);
    }
    this.isModalOpenSignal.set(true);
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.isModalOpenSignal.set(false);
    document.body.style.overflow = 'auto';
  }
}
